'use client';

import React from 'react';
import { Link } from '../../utils/router';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-section">
            <div className="footer-logo">
              <span className="footer-logo-mark" aria-hidden="true">
                <svg className="footer-logo-mark-svg" viewBox="0 0 40 40" fill="none">
                  <rect x="1.5" y="1.5" width="37" height="37" rx="14" stroke="currentColor" strokeOpacity="0.22" />
                  <path d="M16 28V12H23.2C27.0188 12 29.5 14.2185 29.5 17.5C29.5 20.7815 27.0188 23 23.2 23H16" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </span>
              <span className="footer-logo-text">PuiPi</span>
            </div>
            <p className="footer-desc">
              專為寵物愛好者打造的二手交易平台，讓每個毛孩都能享受優質用品。
            </p>
          </div>
          <div className="footer-section">
            <h4 className="footer-title">快速連結</h4>
            <ul className="footer-links">
              <li><Link to="/">首頁</Link></li>
              <li><Link to="/sell">我要賣</Link></li>
              <li><Link to="/favorites">我的收藏</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4 className="footer-title">關於</h4>
            <ul className="footer-links">
              <li><Link to="/about">關於我們</Link></li>
              <li><Link to="/terms">使用條款</Link></li>
              <li><Link to="/privacy">隱私政策</Link></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4 className="footer-title">聯絡我們</h4>
            <ul className="footer-links">
              <li>Email: support@puipi.com</li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 PuiPi. All rights reserved.</p>
          <p className="footer-version">v1.0.1</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
